import { values } from './enums'

const WeekDay = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6
}

const VALUES = values(WeekDay)

export {
  WeekDay,
  VALUES
}



// WEBPACK FOOTER //
// ./src/enums/WeekDays.js